import React, { Suspense } from "react";
import { Switch } from "react-router-dom";
import { ContentRoute, LayoutSplashScreen } from "../../../../_metronic/layout";
import { KYCUserGroupMenu } from "../../Common/layout/aside/aside-menu-lists/KYCUserGroupMenu";
import { AsideMenu } from "../../Common/layout/aside/AsideMenu";
import { Section } from "../../Common/layout/Section";
import { PendingKYC } from "./PendingKYC";
import { Permissions } from "../../../util/Permissions";

const PendingKYCPages = () => {
    return <>
        <AsideMenu>
            <KYCUserGroupMenu destination="/pending-kyc" />
        </AsideMenu>
        <Section>
            <Suspense fallback={<LayoutSplashScreen />}>
                <Switch>
                    <ContentRoute path="/pending-kyc/:userGroup" permission={Permissions.PendingKYC} component={PendingKYC} />
                </Switch>
            </Suspense>
        </Section>
    </>
};

export default PendingKYCPages;
